import React from 'react'
import abImg1 from '../../images/faxian-it-images/about-section-1.jpg'
import abImg2 from '../../images/about/award-icon-2.svg'
import Signeture from '../../images/about/signeture.png'
// import Accordion from '../ServiceSinglePage/accordion'
import Accordion from "../../main-component/ServiceSinglePage/accordion"



const About = (props) => {

    return (
        <section className="about-section section-padding">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-xl-6 col-12">
                        <div className="about-left-content">
                            <div className="image">
                                <img src={abImg1} alt="" />
                            </div>
                            {/* <div className="award-content">
                                <div className="icon">
                                    <img src={abImg2} alt="" />
                                </div>
                                <h2>Award Winning</h2>
                                <p>We have a history of successfully delivering IT solutions to a great diverse
                                    clientele, from startups to established enterprises.</p>
                            </div> */}
                        </div>
                    </div>
                    <div className="col-xl-6 col-12">
                        <div className="about-right-content">
                            <h2 className="title">About Us – Faxian IT</h2>
                            <h3 className="sub-title">Your Trusted Partner in Technology & Innovation</h3>
                            <p className="text">Faxian IT is a trusted technology partner delivering cloud solutions, IT consulting, and software development to help businesses innovate, scale, and succeed in the digital era.
                                {/* <span>our mission is clear – to provide comprehensive and customized IT solution that
                                    </span> */}
                            </p>
                            {/* <div className="ceo-content">
                                <h2>Venkat</h2>
                                <span>CEO & Founder of Faxian IT</span>
                                <div className="signeture">
                                    <img src={Signeture} alt="" />
                                </div>
                            </div> */}
                        </div>

                                
                                   <div className="benefits-item">
                                                <Accordion />
                                            </div>

                    </div>
                </div>



              





            </div>
            <div className="shape-1">
                <svg width="429" height="593" viewBox="0 0 429 593" fill="none">
                    <circle cx="296.5" cy="296.5" r="296.5" fill="url(#cc318_1506)" />
                    <defs>
                        <radialGradient id="cc318_1506" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
                            gradientTransform="translate(296.5 296.5) rotate(90) scale(296.5)">
                            <stop offset="0" stopColor="#CED0FF" />
                            <stop offset="1" stopColor="white" stopOpacity="0" />
                        </radialGradient>
                    </defs>
                </svg>
            </div>
            <div className="shape-2">
                <svg width="529" height="529" viewBox="0 0 529 529" fill="none">
                    <circle cx="264.5" cy="264.5" r="264.5" fill="url(#oo1508)" />
                    <defs>
                        <radialGradient id="oo1508" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
                            gradientTransform="translate(264.5 264.5) rotate(90) scale(264.5)">
                            <stop offset="0" stopColor="#FBB132" stopOpacity="0.2" />
                            <stop offset="1" stopColor="white" stopOpacity="0" />
                        </radialGradient>
                    </defs>
                </svg>
            </div>
        </section>
    )
}

export default About;



